// ---------------------------------------------------------------
// Mobile navigation toggle
// ---------------------------------------------------------------
const navToggle = document.querySelector('.nav-toggle');
const navLinks  = document.querySelector('.nav-links');

if (navToggle && navLinks) {
  const closeNav = () => {
    navLinks.classList.remove('open');
    navToggle.setAttribute('aria-expanded', 'false');
  };

  navToggle.addEventListener('click', () => {
    const expanded = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!expanded));
    navLinks.classList.toggle('open');
  });

  // Close menu when a link is clicked
  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      closeNav();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && navLinks.classList.contains('open')) {
      closeNav();
      navToggle.focus();
    }
  });
}

// ---------------------------------------------------------------
// Active nav link highlighting
// ---------------------------------------------------------------
const setActiveLink = () => {
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  const links = document.querySelectorAll('.nav-links a');

  links.forEach(link => {
    const linkPath = new URL(link.href).pathname.replace(/\/$/, '') || '/';
    link.classList.toggle('active', linkPath === currentPath);
  });
};

setActiveLink();

// ---------------------------------------------------------------
// Smooth scroll for anchor links (supplements CSS scroll-behavior)
// ---------------------------------------------------------------
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ---------------------------------------------------------------
// Sticky nav: add shadow when scrolled
// ---------------------------------------------------------------
const nav = document.querySelector('nav');

if (nav) {
  const onScroll = () => {
    nav.style.boxShadow = window.scrollY > 10
      ? '0 4px 20px rgba(0,0,0,0.35)'
      : '0 2px 12px rgba(0,0,0,0.25)';
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}

// ---------------------------------------------------------------
// YouTube live stream detection (cricket page)
// Shows the live-stream section only when the channel is streaming.
// Uses the YouTube oEmbed endpoint via JSONP (no API key, no CORS issue).
// The oEmbed endpoint returns 404 when the channel is not live, which
// triggers the script's onerror handler, keeping the section hidden.
// ---------------------------------------------------------------
(function () {
  var liveSection = document.getElementById('yt-live-section');
  var liveFrame   = document.getElementById('yt-live-frame');
  if (!liveSection || !liveFrame) return;

  var CHANNEL_ID = 'UCpQ0O5jM90_XzGyFNR7GZ5Q';
  var LIVE_URL   = 'https://www.youtube.com/channel/' + CHANNEL_ID + '/live';
  var EMBED_URL  = 'https://www.youtube.com/embed/live_stream?channel=' + CHANNEL_ID + '&autoplay=1&mute=1';

  // Unique callback name (timestamp + random suffix avoids millisecond collisions)
  var cbName = 'ytLiveCheck_' + Date.now() + '_' + Math.random().toString(36).slice(2);

  var script = document.createElement('script');

  function cleanup() {
    delete window[cbName];
    if (script.parentNode) {
      script.parentNode.removeChild(script);
    }
  }

  window[cbName] = function () {
    // oEmbed responded with data – channel is currently live
    liveFrame.src = EMBED_URL;
    liveSection.style.display = '';
    cleanup();
  };

  script.src = 'https://www.youtube.com/oembed?url=' + encodeURIComponent(LIVE_URL) +
               '&format=jsonp&callback=' + cbName;
  script.onerror = function () {
    // 404 returned by oEmbed – channel is not live; section stays hidden
    cleanup();
  };
  document.head.appendChild(script);
}());

// ---------------------------------------------------------------
// Sponsors carousel (auto-rotates every 15 seconds, no navigation)
// ---------------------------------------------------------------
(function () {
  const track = document.querySelector('.sponsors-track');

  if (!track) return;

  const slides = track.querySelectorAll('.sponsor-slide');
  if (slides.length < 2) return;

  let current = 0;

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
  }

  function next() { goTo(current + 1); }

  goTo(0);
  setInterval(next, 15000);
}());
